/* ===================================================================
   DESPEVESTE — Script
   Menu, Scroll Reveal, Filters, Accordion, Form → WhatsApp
   =================================================================== */

(function() {
  'use strict';

  // ===== NAVBAR SCROLL =====
  const nav = document.querySelector('.nav');
  if (nav) {
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      nav.classList.toggle('scrolled', y > 20);
      lastScroll = y;
    }, { passive: true });
  }

  // ===== HAMBURGER MENU =====
  const hamburger = document.querySelector('.hamburger');
  const mobileMenu = document.querySelector('.mobile-menu');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      const isOpen = mobileMenu.classList.contains('open');
      mobileMenu.classList.toggle('open');
      hamburger.classList.toggle('open');
      document.body.classList.toggle('menu-open');
      hamburger.setAttribute('aria-label', isOpen ? 'Abrir menu' : 'Fechar menu');
    });

    // Close on link click
    mobileMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        mobileMenu.classList.remove('open');
        hamburger.classList.remove('open');
        document.body.classList.remove('menu-open');
      });
    });

    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileMenu.classList.contains('open')) {
        mobileMenu.classList.remove('open');
        hamburger.classList.remove('open');
        document.body.classList.remove('menu-open');
        hamburger.focus();
      }
    });
  }

  // ===== SCROLL REVEAL =====
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, { threshold: 0.08 });

  document.querySelectorAll('.r').forEach(el => observer.observe(el));

  // ===== COLLECTION FILTERS =====
  const filterBtns = document.querySelectorAll('.filter-btn');
  const productCards = document.querySelectorAll('.product-card[data-category]');

  if (filterBtns.length && productCards.length) {
    filterBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        // Update active
        filterBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        const filter = btn.dataset.filter;

        productCards.forEach(card => {
          const categories = card.dataset.category || '';
          if (filter === 'all' || categories.includes(filter)) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        });
      });
    });

    // Handle hash navigation (#vestuario, #acessorios)
    const hash = window.location.hash.replace('#', '');
    if (hash) {
      const targetBtn = document.querySelector(`.filter-btn[data-filter="${hash}"]`);
      if (targetBtn) {
        targetBtn.click();
      }
    }
  }

  // ===== PDP SIZE SELECTOR =====
  document.querySelectorAll('.pdp-size:not(.disabled)').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.pdp-size').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  // ===== PDP COLOR SELECTOR =====
  document.querySelectorAll('.pdp-color-swatch').forEach(swatch => {
    swatch.addEventListener('click', () => {
      document.querySelectorAll('.pdp-color-swatch').forEach(s => s.classList.remove('active'));
      swatch.classList.add('active');
      // Update label
      const label = document.querySelector('.pdp-color-label');
      if (label) {
        label.textContent = 'Cor: ' + (swatch.getAttribute('aria-label') || '');
      }
    });
  });

  // ===== ACCORDION =====
  document.querySelectorAll('.pdp-accordion-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.pdp-accordion-item');
      const content = item.querySelector('.pdp-accordion-content');
      const inner = content.querySelector('.pdp-accordion-content-inner');
      const isOpen = item.classList.contains('open');

      // Close all others in same accordion
      const accordion = item.closest('.pdp-accordion');
      accordion.querySelectorAll('.pdp-accordion-item').forEach(other => {
        if (other !== item) {
          other.classList.remove('open');
          other.querySelector('.pdp-accordion-btn').setAttribute('aria-expanded', 'false');
          other.querySelector('.pdp-accordion-content').style.maxHeight = '0';
        }
      });

      // Toggle current
      if (isOpen) {
        item.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
        content.style.maxHeight = '0';
      } else {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
        content.style.maxHeight = inner.scrollHeight + 'px';
      }
    });
  });

  // ===== CONTACT FORM → WHATSAPP =====
  const contactForm = document.getElementById('contactForm');
  if (contactForm) {
    contactForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const data = new FormData(contactForm);
      let msg = '📋 *Nova mensagem do site Despeveste*\n\n';
      data.forEach((value, key) => {
        if (value) msg += `*${key}:* ${value}\n`;
      });
      window.open('https://wa.me/351938699245?text=' + encodeURIComponent(msg));
    });
  }

  // ===== ADD TO CART (demo feedback) =====
  const addToCartBtn = document.querySelector('.btn-add-cart');
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', () => {
      const original = addToCartBtn.textContent;
      addToCartBtn.textContent = 'Adicionado';
      addToCartBtn.style.background = 'var(--gray-600)';
      setTimeout(() => {
        addToCartBtn.textContent = original;
        addToCartBtn.style.background = '';
      }, 2000);
    });
  }

})();
